import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux';
import XAxisProps from './CustomComponents/X-AxisProps';
import InputNumber from '../CommonFunctions/InputNumber';
import SwitchWithInput from '../SwitchWithInput';
import {
  enableGrid,
  updateAxisMinMax,
  updateAxisMinMaxforScatter,
  updateAxisOptions,
  updateReverse,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import YAxisProps from './CustomComponents/Y-AxisProps';
import { ChartConAxisOptions } from '../../../redux/ChartPoperties/ChartControlsInterface';
import { Box, Divider } from '@mui/material';

export const textFieldStyleProps = {
  style: {
    fontSize: '12px',
    width: '93%',
    margin: '0 0.5rem 0.5rem 0.5rem',
    //backgroundColor: 'white',
    height: '1.5rem',
    // color: '#404040',
  },
};
const GridAndAxes = ({
  iconColor,
  backgroundColor,
}: {
  iconColor?: string;
  backgroundColor?: string;
}) => {
  const { chartControls, tabTileProps, chartProperties } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
  }));
  const dispatch = useDispatch();

  const propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const property: ChartConAxisOptions = chartControls.properties[propKey].axisOptions;
  const chartType = chartProperties.properties[propKey].chartType;
  const { enableMin, minValue, enableMax, maxValue } = property.axisMinMax;
  const minMaxError = enableMin && enableMax && Number(minValue) >= Number(maxValue);

  const showMinMaxHeaderCharts = ['stackedArea', 'horizontalStacked', 'waterfall', 'stackedBar'];

  const handleSetAxisMinMax = (axisKey: string, axisValue: any) => {
    dispatch(updateAxisMinMax(propKey, axisKey, axisValue));
  };

  const handleSetReverse = (value: boolean) => {
    dispatch(updateReverse(propKey, value));
  };

  const handleEnableGrids = (key: string, option: string, value: any) => {
    dispatch(enableGrid(key, option, value));
  };

  const handleUpdateAxisOptions = (
    axis: string,
    option: string,
    value: any,
    seriesKey?: string,
  ) => {
    dispatch(updateAxisOptions(propKey, axis, option, value, seriesKey));
  };

  const handleUpdateAxisMinMaxForScatter = (axisKey: string, axisValue: any) => {
    dispatch(updateAxisMinMaxforScatter(propKey, axisKey, axisValue));
  };

  return (
    <div className="optionsInfo">
      {chartType !== 'scatterPlot' && (
        <>
          <div
            className="optionDescription"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '5px',
              paddingLeft: '0.45rem',
              paddingBottom: '0.65rem',
            }}
          >
            <label
              htmlFor="enableDisable"
              className="enableDisableLabel"
              style={{
                fontWeight: 600,
                margin: 0,
                padding: 0,
                cursor: 'pointer',
                marginTop: '-8px',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              Invert Axis
            </label>

            <Box
              sx={{
                width: '50px',
                height: '24px',
                display: 'flex',
                transform: 'translateX(63px)',
                marginBottom: '9px',
                '@supports (-moz-appearance: none)': {
                  transform: 'translateX(55px)',
                },
              }}
            >
              <SwitchWithInput
                isChecked={property.inverse}
                onSwitch={() => handleSetReverse(!property.inverse)}
              />
            </Box>
          </div>
          <Divider
            sx={{
              height: '1px',
              backgroundColor: 'rgba(224, 224, 224, 1)',
              border: 'none',
              marginLeft: '0.45rem',
            }}
          />
          {showMinMaxHeaderCharts.includes(chartType) && (
            <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
              Range(Axis Values)
            </div>
          )}
          {/* In the below four charts, the min and max values are displayed individually for each series. Code for that is written inside SeriesAxisOptions.tsx component */}
          {/* // added heatmap(already have for dimension and measure), boxPlot and waterfall to the list so they don't show min max options , because we are not using min max for them */}
          {!['line', 'area', 'multibar', 'horizontalBar', 'heatmap', 'boxPlot'].includes(
            chartType,
          ) && (
            <>
              <div
                className="optionDescription"
                style={{
                  paddingTop: '0',
                  color: iconColor ? iconColor : '#404040',
                }}
              >
                Min Value
              </div>
              <div
                className="optionDescription"
                style={{
                  marginTop: '0',
                  paddingTop: '2px',
                  color: iconColor ? iconColor : '#404040',
                }}
              >
                <input
                  type="checkbox"
                  style={{ width: '16px', height: '16px' }}
                  id="enableMin"
                  checked={property.axisMinMax.enableMin}
                  onChange={() => {
                    const isEnabling = !property.axisMinMax.enableMin;
                    handleSetAxisMinMax('enableMin', isEnabling);
                  }}
                />

                <InputNumber
                  value={property.axisMinMax.enableMin ? property.axisMinMax.minValue : ''}
                  updateValue={(value: number) => handleSetAxisMinMax('minValue', value)}
                  disabled={!property.axisMinMax.enableMin}
                />
              </div>
              <div
                style={{
                  borderBottom: '1px solid rgb(211,211,211)',
                }}
              >
                <div
                  className="optionDescription"
                  style={{
                    marginTop: '5px',
                    color: iconColor ? iconColor : '#404040',
                  }}
                >
                  Max Value
                </div>
                <div
                  className="optionDescription"
                  style={{
                    marginTop: '0',
                    paddingTop: '2px',
                    marginBottom: '20px',
                    color: iconColor ? iconColor : '#404040',
                  }}
                >
                  <input
                    type="checkbox"
                    style={{ width: '16px', height: '16px' }}
                    id="enableMax"
                    checked={property.axisMinMax.enableMax}
                    onChange={() => {
                      const isEnabling = !property.axisMinMax.enableMax;
                      handleSetAxisMinMax('enableMax', isEnabling);
                    }}
                  />

                  <InputNumber
                    value={property.axisMinMax.enableMax ? property.axisMinMax.maxValue : ''}
                    updateValue={(value: number) => handleSetAxisMinMax('maxValue', value)}
                    disabled={!property.axisMinMax.enableMax}
                  />
                </div>
                {minMaxError && (
                  <div
                    style={{
                      color: '#d32f2f',
                      fontSize: '12px',
                      marginTop: '-15px',
                      marginBottom: '15px',
                      textAlign: 'left',
                      paddingLeft: '10px',
                    }}
                  >
                    Max value should be greater than Min Value
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}

      <XAxisProps
        propKey={propKey}
        chartType={chartType}
        property={property}
        xAxisProps={property.xAxis[1]}
        updateAxisOptions={handleUpdateAxisOptions}
        updateAxisMinMaxforScatter={handleUpdateAxisMinMaxForScatter}
        enableGrids={handleEnableGrids}
        iconColor={iconColor}
        backgroundColor={backgroundColor}
      />
      <Divider
        sx={{
          height: '1px',
          backgroundColor: 'rgba(224, 224, 224, 1)',
          border: 'none',
          marginLeft: '0.45rem',
        }}
      />
      <YAxisProps
        propKey={propKey}
        chartType={chartType}
        property={property}
        yAxisProps={property.yAxis[1]}
        updateAxisOptions={handleUpdateAxisOptions}
        updateAxisMinMaxforScatter={handleUpdateAxisMinMaxForScatter}
        enableGrids={handleEnableGrids}
        iconColor={iconColor}
        backgroundColor={backgroundColor}
      />
    </div>
  );
};

export default GridAndAxes;
